import API from "../../utils/API";

export default {
  async backstageLogin(context, loginData) {
    let response = await API.backPOST(`/admin/login`, loginData);
    return response;
  },
  setBackstageToken({ commit }, token) {
    commit("setBackstageToken", token);
  },
  async backstageLoginOut() {
    let response = await API.backPOST(`/admin/logout`);
    return response;
  },
  deleteBackstageToken({ commit }) {
    commit("deleteBackstageToken");
  },
  setAdminLevel({ commit }, level) {
    commit("setAdminLevel", level);
  },
  async getSpecialMemberList(context, paginationData) {
    let response = await API.backGET(`/users/special-member`, paginationData);
    return response;
  },
  async specialMemberApplyPass(context, id) {
    let response = await API.backPATCH(`/users/special-member/${id}`);
    return response;
  },
  async deleteSpecialMember(context, id) {
    let response = await API.backDELETE(`/users/special-member/${id}`);
    return response;
  },
  async sendLayoutCheckMail(context, mailData) {
    let response = await API.backPOST(
      `/admin/orders/${mailData.id}/notify`,
      mailData.data
    );
    return response;
  },
  async checkHaveCheckout(context, id) {
    let response = await API.backPATCH(`/admin/orders/${id}/checkPayment`);
    return response;
  },
  async getReportData(context, id) {
    let response = await API.backPOST(`/admin/report`, id);
    return response;
  },
  async getPrintGuaranteeData(context, id) {
    let response = await API.backPOST(`/admin/warranty`, id);
    return response;
  },
  async getPrintMailData(context, id) {
    let response = await API.backPOST(`/admin/post`, id);
    return response;
  },
  async updatePostalCost(context, { id, updateCostData }) {
    let response = await API.backPOST(
      `/admin/orders/${id}/postalCost`,
      updateCostData
    );
    return response;
  },
  pickupSelf(context, id) {
    return API.backPOST(`/admin/orders/${id}/pickup`);
  },
  //後台訂單首頁
  updateCurrentOrderStatus({ commit }, status) {
    commit("updateCurrentOrderStatus", status);
  },
  updateCurrentOrderPage({ commit }, page) {
    commit("updateCurrentOrderPage", page);
  },
  updateCurrentOrderKeyword({ commit }, keyword) {
    commit("updateCurrentOrderKeyword", keyword);
  },
  updateCurrentOrderDate({ commit }, date) {
    commit("updateCurrentOrderDate", date);
  },
  updateCurrentOrderDateFrom({ commit }, date) {
    commit("updateCurrentOrderDateFrom", date);
  },
  updateCurrentOrderDateTo({ commit }, date) {
    commit("updateCurrentOrderDateTo", date);
  }
};
